module.exports = __webpack_public_path__ + "static/uscar.1db637a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/uscar.png
// module id = 2210
// module chunks = 61762850755587